import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
@Component({
  selector: 'app-empresa-riesgo',
  templateUrl: './empresa-riesgo.component.html',
  styleUrls: ['./empresa-riesgo.component.scss']
})
export class EmpresaRiesgoComponent   {

  constructor(private loginService:LoginService) { }

 
  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
